<template>
    <drag-modal :visible="visible" @cancel="close" title="分享文件" width="400px">
        <div class="select-box">
            <a-select v-model="uname" style="width: 100%;" placeholder="请选择分享成员" mode="multiple" show-search
                :allowClear="true" :maxTagCount="1" class="nselect" option-filter-prop="children"
                :filter-option="filterOption" @search="handleSearch" @blur="handleSelectBlur">
                <a-select-option v-for="user in allUsers" :key="user.id" :value="user.id">
                    {{ user.uname }}
                </a-select-option>
            </a-select>
            <a-button type="primary" ghost class="send-btn" @click="confirm">
                <img src="https://zhesubao.oss-cn-hangzhou.aliyuncs.com/admin/system/file/2026-09-10/直接发送-copy(3569).png"
                    class="send-icon" alt="直接发送" />
                <span>发送</span>
            </a-button>
        </div>
        <!-- 分组列表 -->
        <div class="session-list">
            <div v-for="group in filterSessionList" :key="group.id" class="session-group">
                <!-- 分组 -->
                <div class="group-header" @click="toggleGroup(group.id)">
                    <a-icon :type="expandedGroups[group.id] ? 'caret-down' : 'caret-right'" class="group-arrow" />
                    <span class="group-name">{{ group.title }} </span>
                </div>
                <!-- 成员 -->
                <transition name="slide-down">
                    <div v-show="expandedGroups[group.id]" class="group-children">
                        <div v-for="session in group.children" :key="session.id"
                            :class="['session-item', { selected: isSelected(session) }]"
                            @click.stop="toggleUser(session)">
                            <a-avatar :icon="session.audit == 0 ? 'exclamation-circle' : session.avatar ? null : 'user'"
                                :size="32"
                                :style="{ background: session.audit == 0 ? '#f85b5040' : session.status == 'offline' ? '#a3a3a3  ' : '#2d6fc4' }" />
                            <div class="session-info">
                                <div class="session-name">
                                    <div
                                        :class="['session-uname', { online: session.status == 'online' }, { greyuname: !isSelected(session) }]">
                                        {{ session.uname }}
                                    </div>
                                    <div
                                        :class="['session-status', session.audit == 0 ? 'disable' : session.status == 'offline' ? 'grey' : '']">
                                        {{ session.audit == 0 ? '已禁用' : session.status == 'online' ? '在线' : '离线' }}
                                    </div>
                                </div>
                            </div>
                            <!-- 选中-->
                            <a-icon v-if="isSelected(session)" type="check" class="selected-icon" />
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <!-- 没有搜索结果 -->
        <div v-if="searchKeyword && filterSessionList.length === 0" class="empty-tip">
            未找到相关成员
        </div>
    </drag-modal>
</template>

<script>

export default {
    name: "PopUpFileInformation",
    props: {
        FileInformation: Object
    },
    data() {
        return {
            // 分组数据
            sessionList: [],
            // 分组展开状态
            expandedGroups: {},
            // 已选中的成员ID
            uname: [],
            // 所有成员，用于 a-select
            allUsers: [],
            // 当前搜索关键字
            searchKeyword: ""
        };
    },

    computed: {

        visible() {
            return this.$store.state.dislog.PopUpFileInformation;
        },        // 根据搜索内容过滤下面的成员列表
        filterSessionList() {
            const keyword = this.searchKeyword.trim().toLowerCase();
            // 没有搜索内容，恢复原始数据
            if (!keyword) return this.sessionList;
            return this.sessionList
                .map(group => {
                    const children = (group.children || []).filter(session => {
                        if (!session || !session.uname) return false
                        return session.uname.toLowerCase().includes(keyword);
                    });
                    return { ...group, children };
                }).filter(group => group.children.length > 0);
        }
    },

    watch: {
        // 搜索的时候自动展开匹配的分组
        searchKeyword(val) {
            const keyword = val.trim();
            if (!keyword) return;
            this.filterSessionList.forEach(group => {
                this.$set(
                    this.expandedGroups,
                    group.id,
                    true
                );
            });
        }
    },

    mounted() {
        this.getSessionList();
    },

    methods: {
        handleSelectBlur() {
            // a-select 失去焦点时，清空搜索关键字
            // 这样下面的 session-list 会自动恢复完整数据
            this.searchKeyword = "";
        },
        handleSearch(value) {
            this.searchKeyword = value || "";
            // 搜索框为空时，立即恢复完整分组数据
            if (!this.searchKeyword.trim()) {
                this.searchKeyword = "";
            }
        },
        filterOption(input, option) {
            const text =
                option.componentOptions &&
                    option.componentOptions.children &&
                    option.componentOptions.children[0]
                    ? option.componentOptions.children[0].text
                    : "";
            return text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        // 获取成员列表
        async getSessionList() {
            const { sessions } = await import("@/server/chat");
            const res = await sessions();
            this.sessionList = res.list || [];
            // 整理所有成员
            this.buildAllUsers();
            // 默认展开第一组
            this.expandFirstGroup();
        },
        // 整理所有成员
        buildAllUsers() {
            const users = [];
            const userMap = {};
            this.sessionList.forEach(group => {
                if (!group.children) return
                group.children.forEach(session => {
                    if (!session) return
                    // 防止成员重复
                    if (userMap[session.id]) return
                    userMap[session.id] = true;
                    users.push({
                        id: session.id,
                        uname: session.uname
                    });
                });
            });
            this.allUsers = users;
        },
        // 关闭弹窗
        close() {
            this.$store.dispatch("openkey", {
                key: "PopUpFileInformation",
                by: false
            });
            this.searchKeyword = "";
            this.uname = []
        },
        // 展开 / 收起分组
        toggleGroup(groupId) {
            this.$set(
                this.expandedGroups,
                groupId,
                !this.expandedGroups[groupId]
            );
        },
        // 默认展开第一组
        expandFirstGroup() {
            if (!this.sessionList || this.sessionList.length === 0) return
            // 先关闭所有分组
            this.sessionList.forEach(group => {
                this.$set(
                    this.expandedGroups,
                    group.id,
                    false
                );
            });
            // 展开第一组
            const firstGroup = this.sessionList[0];
            this.$set(
                this.expandedGroups,
                firstGroup.id,
                true
            );
        },
        // 判断成员是否选中
        isSelected(session) {
            return this.uname.indexOf(session.id) !== -1;
        },
        // 点击成员进行多选
        toggleUser(session) {
            // console.log(session, this.FileInformation);
            const index = this.uname.indexOf(session.id);
            if (index === -1) {
                // 未选中 -> 选中
                this.uname.push(session.id);
            } else {
                // 已选中 -> 取消
                this.uname.splice(index, 1);
            }
            // 下方列表自动恢复原来的全部数据
            this.searchKeyword = "";
        },
        async confirm() {
            if (!this.uname.length) { this.$message.warning("请选择要分享的成员"); return }
            const { pushShareMessage } = await import("@/server/api");
            let form = JSON.parse(JSON.stringify({
                receivers: this.uname,
                content: this.FileInformation.file_key,
                message_type: 'document',
                file_name: this.FileInformation.file_name
            }))
            const res = await pushShareMessage(Object.assign(form));
            if (res.send_count) { 
                this.$message.success(
                    { 
                        content: (<span> 分享成功！ 
                                    <span style="color: #108aee; cursor: pointer; margin-left: 4px;" 
                                        onClick={() => { 
                                            this.$store.dispatch("openkey", { key: 'chat', by: true });
                                            this.$store.dispatch("openkey", { key: 'filemanage', by: false });
                                        }} > 
                                        点击即可前往聊天查看 
                                    </span> 
                                </span>), 
                        duration: 3 
                    }); 
                }
                
            this.$nextTick(() => {
                this.$emit("expand-first-group");
            })
            this.close()
        }
    }
};
</script>

<style lang="less" scoped>
.session-list {
    max-height: 505px;
    overflow-y: auto;
}

.session-group {
    padding: 0 16px;
}

.select-box {
    width: 100%;
    padding: 12px 16px;
    box-sizing: border-box;
    background: #ffffff;
    border-bottom: 1px solid #f5f5f5;
    display: flex;
    gap: 10px;
    align-items: center;
}

.send-btn {
    flex-shrink: 0;
    height: 32px;
    padding: 0 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
}

.send-btn span {
    color: #108aee !important;
}

.send-icon {
    width: 18px;
    height: 18px;
    object-fit: contain;
    vertical-align: middle;
}

.group-header {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    background: #ffffff;
    transition: background 0.2s;
    user-select: none;

    /* 滚动到顶部后固定 */
    position: sticky;
    top: 0;
    z-index: 10;
}

.group-header:hover {
    background: #e8ecf1;
}

.group-arrow {
    font-size: 12px;
    color: #8aa8c8;
    margin-right: 8px;
}

.group-name {
    flex: 1;
    font-size: 15px;
    font-weight: 600;
    color: #1a3a6a;

}

.group-badge {
    margin-left: 4px;

}

.group-children {
    overflow: hidden;
}

.session-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 10px 8px 30px;
    cursor: pointer;
    transition: background 0.2s;
    border-bottom: 1px solid #f5f5f5;
    position: relative;
    // margin-left: 30px;
    // margin-right: 20px;
}

.session-item:hover {
    background: #e1f1ff;
}

.session-item.selected {
    background: #108aee4f;
}

.session-item.selected:hover {
    background: #108aee4f;
}

.session-badge {
    position: absolute;
    top: 4px;
    left: 30px;
}

.session-info {
    flex: 1;
    min-width: 0;
}

.session-name {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
}

.session-uname {
    // color: #2d6fc4;
    // font-weight: 600;
}

.greyuname {
    color: #333;
    font-weight: 400;
}

.online {
    color: #2d6fc4;
}

.session-item.selected .session-uname {
    // color: #1a3a6adc ;
    // font-weight: 600;
}

.selected-icon {
    color: #1a3a6a;
    font-size: 16px;
    margin-left: auto;
}

.session-time {
    font-size: 10px;
    color: #999;
}

.session-status {
    padding: 0 4px;
    background-color: #fff;
    color: #0ac903;
    border: 1px solid #0ac903;
    border-radius: 4px;
    font-size: 9px;
    margin-left: 6px;
}

.grey {
    color: #a3a3a3;
    border: 1px solid #a3a3a3;
}

.disable {
    color: #f85b5060;
    border: 1px solid #f85b5060;
}

.disablename {
    color: #f85b5060 !important;
    font-weight: 400;
}

.warning-tip {
    width: 100%;
    height: 40px;
    font-size: 14px;
    color: #fc382a;
    text-align: center;
    background-color: #f7d6d6;
    line-height: 40px;
}

.session-preview {
    width: 140px;
    font-size: 11px;
    color: #999;
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

:deep(.ant-modal-body) {
    padding: 0 !important;
}

.slide-down-enter-active,
.slide-down-leave-active {
    transition: all 0.25s ease;
}

.slide-down-enter,
.slide-down-leave-to {
    opacity: 0;
    max-height: 0;
}

.slide-down-enter-to,
.slide-down-leave {
    opacity: 1;
    max-height: 500px;
}
</style>